import { makeStyles } from '@material-ui/core/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  titleTight: {
    '&&': {
      paddingBottom: 8,
    },
  },
  title: {
    color: palette.primary.main,
    flexWrap: 'wrap',
    display: 'flex',
    textAlign: 'left',
    justifyContent: 'flex-start',
    width: '100%',
  },
  dividerTight: {
    marginBottom: 8,
  },
  contentTight: {
    '&&': {
      paddingTop: '12px !important',
    },
  },
  dialogContent: {
    width: '100%',
    fontSize: spacing(Theme.Typography.FontSize.XXSmall),
    fontWeight: Theme.Typography.FontWeight.Small,
    fontStyle: 'normal',
    lineHeight: '20px',

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'gray',
    },
    '&.MuiDialogContent-dividers': {
      borderBottom: '0px',
    },
  },
  text: {
    fontSize: spacing(Theme.Typography.FontSize.XXSmall),
    lineHeight: spacing(16),
    color: palette.gray[64],
    marginTop: spacing(25),
    fontFamily: Theme.Typography.FontFamily.Roboto,
  },
  required: {
    color: '#C90000',
  },
  select: {
    marginBottom: spacing(10),
    minWidth: spacing(120),
  },
  input: {
    '& .MuiOutlinedInput-multiline': {
      alignItems: 'baseline',
      minHeight: spacing(104),
      marginTop: spacing(10),
      marginBottom: '5px',
    },
  },
  msgInput: {
    marginTop: spacing(10),
    marginBottom: '5px',
    width: '100%',
  },
  btnWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '16px',
    gap: '10px',
  },
  button: {
    width: '100px',
    padding: '10px 0',
    borderRadius: '24px',
  },
  column: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  section: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'space-around',
  },
  subsection: {
    display: 'flex',
    gap: '20px',
  },
}))
